/**
 * Labstep
 *
 * @module constants/version
 * @desc App version
 */

export const APP_VERSION = '13.14.9';
